import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { uploadDocument } from "../../../apis/invoicingApis";
import { AddIcon } from "../../../components/Icon";
import { BlobServiceClient } from "@azure/storage-blob";
import { Loader, ErrorSuccessModal } from "../../../components/commons";
import { UploadIcon } from "../../../assets/images";

import "./upload.scss";

interface Props {
  handleUpload: Function;
  setFileNames: Function;
  fileNames: any;
  acceptedFileTypes?: string;
  type?: string;
}

const DraggableUpload = ({
  handleUpload,
  setFileNames,
  fileNames,
  acceptedFileTypes,
  type,
}: Props) => {
  // const [fileNames, setFileNames]= useState([])

  const [loading, setLoading] = useState(false);
  const [showModal, setModal] = useState(false);

  const handleDrop = (acceptedFiles: any[string]) => {
    setFileNames(
      acceptedFiles && acceptedFiles.map((file: { name: any }) => file.name)
    );
    // setFileData(acceptedFiles);
    if (
      acceptedFiles &&
      acceptedFiles &&
      acceptedFiles.length &&
      acceptedFiles[0]
    )
      handleUpload(acceptedFiles[0]);
  };

  const maxSize = 10000000; //10mb file size
  return (
    <>
      <Dropzone
        accept={
          acceptedFileTypes ||
          ".csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
        minSize={0}
        maxSize={maxSize}
        onDrop={handleDrop}
        multiple={false}
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isDragReject,
          fileRejections,
        }) => {
          const isFileTooLarge =
            fileRejections.length > 0 &&
            fileRejections[0]?.file?.size > maxSize;

          return (
            <div
              {...getRootProps({ className: "dropzone drop-area text-center" })}
            >
              <input {...getInputProps()} />
              <img src={UploadIcon} />

              {isDragActive && !isDragReject && (
                <h4 className="text-center">Drop it like it's hot!</h4>
              )}

              {isDragReject && (
                <h4 className="text-center">
                  File type not accepted, sorry! Please upload single CSV file
                  at once.
                </h4>
              )}

              {!isDragActive && (
                <h4 className="text-center">
                  Drag'n'drop or click to select a CSV file
                </h4>
              )}
              <p className="text-muted text-center">
                Supported formats: Only .CSV{" "}
              </p>
              <p className="text-center text-muted ">
                Single file upload with maximum of 2000 rows at once supported.
                <br />
                <br />
                {type === "stock" || type === "customers/supplier" ? (
                  ""
                ) : (
                  <small>
                    <strong>
                      Note: Please maintain DD-MM-YYYY date formats in the
                      uploaded CSV file.
                    </strong>
                  </small>
                )}
              </p>
              {isFileTooLarge && (
                <div className="text-danger mt-2">File is too large.</div>
              )}
            </div>
          );
        }}
      </Dropzone>

      <div>
        <ul className="list-group mt-1">
          {fileNames && fileNames.length
            ? fileNames.map((item: string) => (
                <li className="list-group-item" key={item}>
                  <strong> Selected File:</strong> {item}
                </li>
              ))
            : null}
        </ul>
      </div>

      {loading && <Loader />}

      {/* <ErrorSuccessModal
				type="success"
				isOpen={showModal}
				title="Success"
				message="Document Uploaded Successfully "
				buttonText="OK"
				onPress={() => {
					setModal(false);
					fetchNewData()
					toggleModal()
				}}
				statusCode={200}
			/> */}
    </>
  );
};

export default DraggableUpload;
